import { lessonOverviewActionTypes } from './Constants';

const initialState = {
	loading: true,
	data: {
		total_count: 0,
		results: [],
		applied_filters: [],
	},
	error: {},
	appliedFilters: {},
	loadingMyLessons: true,
	myLessons: [],
};

export default function lessonOverviewReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, error } = payload || {};
	const { offset } = data || {};

	switch (type) {
		case lessonOverviewActionTypes.GET_LESSON_OVERVIEW_REQUEST:
			return {
				...state,
				loading: !offset,
			};
		case lessonOverviewActionTypes.GET_LESSON_OVERVIEW_SUCCESS:
			return {
				...state,
				data,
				loading: false,
			};
		case lessonOverviewActionTypes.GET_LESSON_OVERVIEW_ERROR:
			return {
				...state,
				error,
				loading: false,
			};
		case lessonOverviewActionTypes.CHANGE_LESSON_OVERVIEW_FILTERS:
			return {
				...state,
				...data,
			};
		case lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_REQUEST:
			return {
				...state,
				loadingMyLessons: true,
			};
		case lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_SUCCESS:
			return {
				...state,
				myLessons: data,
				loadingMyLessons: false,
			};
		case lessonOverviewActionTypes.GET_MY_SCHEDULED_LESSONS_ERROR:
			return {
				...state,
				error,
				loadingMyLessons: false,
			};
		case lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_SUCCESS:
			return {
				...state,
				recommendedLessons: data,
			};
		case lessonOverviewActionTypes.GET_RECOMMENDED_LESSONS_ERROR:
			return {
				...state,
				error,
			};

		default:
			return state;
	}
}
